
// Polyfill for RxJS for combineLatest that returns a record
// REF: https://gist.github.com/Goobles/45f0b3027d31884dba0b164ee2cc50ea

import { Observable, ObservableInput, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export type ObservableReturnType<T> = T extends Observable<infer R> ? R : any;

export type ObjectWithObservableReturnTypes<T> = {
  [P in keyof T]: ObservableReturnType<T[P]>
};

export function combineLatestRecord<TObj extends { [key: string]: ObservableInput<any> }>(
  observableObject: TObj): Observable<ObjectWithObservableReturnTypes<TObj>> {
  const keys = Object.keys(observableObject);
  return combineLatest(keys.map(key => observableObject[key])).pipe(map(resultArray => {
    const returnObject = {};
    keys.forEach((key, index) => {
      returnObject[key] = resultArray[index];
    });
    return returnObject;
  })) as Observable<ObjectWithObservableReturnTypes<TObj>>;
}
